import { render, staticRenderFns } from "./r-stash-bonus-bunch-dialog.vue?vue&type=template&id=f5a8c16a&scoped=true"
import script from "./r-stash-bonus-bunch-dialog.vue?vue&type=script&lang=js"
export * from "./r-stash-bonus-bunch-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-stash-bonus-bunch-dialog.vue?vue&type=style&index=0&id=f5a8c16a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a8c16a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5a8c16a')) {
      api.createRecord('f5a8c16a', component.options)
    } else {
      api.reload('f5a8c16a', component.options)
    }
    module.hot.accept("./r-stash-bonus-bunch-dialog.vue?vue&type=template&id=f5a8c16a&scoped=true", function () {
      api.rerender('f5a8c16a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/stash/r-stash-bonus-bunch-dialog.vue"
export default component.exports